module.exports = __webpack_public_path__ + "img/logo_fqm_branco.da8cfdab.svg";